const TOAST_IMG_MAP = {
  success: 'success',
  error: 'toast-error',
  info: 'toast-time',
};

export default TOAST_IMG_MAP;
